import { getPropsForClickTracking } from "../../utils/tracking";
$ const { watchlistPillData } = input ?? {};

<if(watchlistPillData)>
  <div data-testid="map-watchlist-pill">
    <ebay-filter-chip
      data-testid="map-watchlist-pill-btn"
      on-click("onWatchlistPillClick")
      selected=input.selected
      ...getPropsForClickTracking(watchlistPillData.action?.trackingList)
    >
      <@icon>
        <ebay-heart-filled-16-icon/>
      </@icon>
      <fe-textual-display model=watchlistPillData.label/>
    </ebay-filter-chip>
  </div>
</if>
